import { checkToken } from '../Twitch';

export default function AuthRoute() {
  checkToken();
  return (
    <>
    </>
  );
}